// extracted by mini-css-extract-plugin
module.exports = {"container":"AttachedImages_container__2_wpZ","label":"AttachedImages_label__9vTKH","title":"AttachedImages_title__2GAC_","images":"AttachedImages_images__7wPJy"};